import { Pipe, PipeTransform } from '@angular/core';
import { NUM_AND_SPACE } from 'src/utilities/constants/number-and-space.regex';

@Pipe({
  name: 'internationalPhone'
})
export class InternationalPhonePipe implements PipeTransform {

  transform(value: string): string {
    let val = value;
    if (val) {
      val = val.trim();
      val = val.split("").filter(c => RegExp(NUM_AND_SPACE).test(c)).join("");
  
      val = val.split("").filter(c => c !== " ").join("")
      val = val.split("").filter(c => c !== "-").join("")
      val = val.split("").filter(c => c !== "(").join("")
      val = val.split("").filter(c => c !== ")").join("")
  
      val = val.slice(-10);
  
      if (val.length > 1 && val.charAt(0) !== "(") {
        val = "(" + val.slice(0);
      }
      
      if (val.length > 4 && val.charAt(4) !== ")") {
        val = val.slice(0, 4) + ")" + val.slice(4);
      }
  
      if ( val.length > 5 && val.charAt(5) !== " ") {
        val = val.slice(0, 5) + " " + val.slice(5);
      }
  
      if ( val.length > 9 && val.charAt(9) !== "-") {
        val = val.slice(0, 9) + "-" + val.slice(9);
      }
    }


    return val;
  }
}
